var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.3,
    height: 33.752,
    viewBox: "0 0 30.3 33.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_11016",
    x: 0,
    y: 0,
    width: 30.3,
    height: 33.752,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9042",
    "data-name": "Group 9042",
    transform: "translate(-1941.152 -3621.138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1941.15, 3621.14)",
    filter: "url(#Path_11016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11016-2",
    "data-name": "Path 11016",
    d: "M-1927.136,4320.89a1.715,1.715,0,0,1-1.712-1.713V4306.85a1.715,1.715,0,0,1,1.712-1.712h6.514v2.994a1.286,1.286,0,0,0,1.285,1.284h2.788v9.761a1.715,1.715,0,0,1-1.712,1.713Zm.71-4.15a.429.429,0,0,0,.428.427h6.6a.428.428,0,0,0,.428-.427.428.428,0,0,0-.428-.428h-6.6A.429.429,0,0,0-1926.426,4316.74Zm0-2.014a.429.429,0,0,0,.428.428h6.6a.428.428,0,0,0,.428-.428.428.428,0,0,0-.428-.428h-6.6A.429.429,0,0,0-1926.426,4314.726Zm0-1.933a.429.429,0,0,0,.428.429h6.6a.429.429,0,0,0,.428-.429.428.428,0,0,0-.428-.428h-6.6A.429.429,0,0,0-1926.426,4312.793Zm7.4-3.854a1.14,1.14,0,0,1-1.142-1.142v-2.66l3.62,3.8Z",
    transform: "translate(1937.85 -4299.14)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocument);
export default __webpack_public_path__ + "static/media/file-document.bbb86173fb0c1e15c9a3a2c87ba3281a.svg";
export { ForwardRef as ReactComponent };